import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/polygamy.pdf'; 
import { Helmet } from 'react-helmet';

function Polygamy() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series VI, volume 3</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 381-382<br /><br />
		Parts of this text can also be found in:<br />
		<var>Textes in&#233;dits tome 2</var><br />
		Gaston Grua (ed)<br />
		pp 852-853<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 4 October 1675<br /><br />
		Translated from the French and Latin<br /><br />{isMobile ? '' : <hr className="centered-hr" />}
		<Link to={pdf} target="_blank">View this translation in PDF format (75k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Polygamy</title>
            <meta name="description" content="An English translation of ON POLYGAMY by Gottfried Wilhelm Leibniz, from 4 October 1675" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON POLYGAMY</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
		        [<b>A VI 3, 381</b>]<br /><br />
                <div align="right">4 Oct. 1675</div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>4 October 1675</var>. This morning I received a letter from Mr. Gallois. I saw Mr. Tschirnhaus, who told me that he had seen in Holland a printed book in Latin, only a few pages long, by a German author who was the prot&#233;g&#233; of Mr Konigsmarck (who was killed before Bonn).<a name="1" href="#note1"><sup>1</sup></a> In this book, he claims to prove that polygamy is necessary and in accordance with the law of God and of nature, and that monogamy is an invention of the devil, the enemy [<b>A VI 3, 382</b>] of humankind and of its increase. He cites numerous passages from holy scripture, which are quite farfetched. He is very well read. Yet he does not permit women to have several husbands. As one might expect. He says that he has spoken with several able men who agreed with him but responded that they would not dare say so openly. He accuses them, on this account, of being cowards who do not dare to admit the acknowledged divine truth, and he says that they commit a sin <var>in spiritum sanctum, ut resistentes agnitae veritati</var>.<a name="2" href="#note2"><sup>2</sup></a> Toward the end he cites this passage from holy scripture: <var>maledictus qui opus Domini negligenter facit</var>,<a name="3" href="#note3"><sup>3</sup></a> and in the margin: <var>NB. hoc est opus Domini</var>,<a name="4" href="#note4"><sup>4</sup></a> which he understands to mean the act of generation.<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mr Tschirnhaus said that there is a bookseller in Holland (in Amsterdam) at whose shop meetings are held by the Cartesians and the Socinians. For that passes for the same thing in Holland.

                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> The Academy editors suggest that this refers to the no-longer extant book by Johann Lyser: <var>Discursus de polygamia</var> (N.p.: n.p. 1673).<br />
                <a name="note2" href="#2">2.</a> 'against the holy spirit, as ones resisting acknowledged truth'.<br />
                <a name="note3" href="#3">3.</a> 'cursed is he who does the work of God negligently'; Jeremiah 48.10.<br />
                <a name="note4" href="#4">4.</a> 'this is the work of the Lord'.<br /><br /><br />
                &#169; Lloyd Strickland 2005. Revised 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Polygamy;
